//搜索Columns
// import BASE_API from '@/api/dataBase.js';
// import API from '@/api/masterData/personnel';
export const searchColumns = (ctx) => {
  return [
    {
      name: '投标抬头',
      prop: 'bidTitle',
      type: 'select',
      options: ctx.companyList,
      changeMethod: 'bidTitleChange',
      // fixme
    },
    {
      name: '申请部门',
      prop: 'applyDepartmentNo',
      type: 'select',
      options: ctx.departmentList,
    },
    {
      name: '业务人员',
      prop: 'bidderId',
      type: 'searchTableSpec',
      searchType: 'personnel',
      changeMethod: 'bidderChange',
      isMultiple: true,
      extraData: {
        dataStatus: 'ZT03',
        personCompanyCode: ctx.userInfo.userInfo.companyCode,
        personDepartmentCode: ctx.userInfo.userInfo.departmentCode,
      },
    },
    {
      name: '立项申请日期',
      prop: 'applyDate',
      type: 'date',
    },
    {
      name: '项目名称',
      prop: 'projectName',
      type: 'input',
    },
    {
      name: '项目编号',
      prop: 'projectCode',
      type: 'input',
    },
    {
      name: '项目来源',
      prop: 'projectSourceType',
      type: 'select',
      options: [
        { value: 'SWQT', label: '商务洽谈' },
        { value: 'TB', label: '投标' },
        { value: 'OT', label: '其他' },
      ],
    },
    {
      name: '服务类型',
      prop: 'serviceTypeCode',
      type: 'select',
      options: [
        { value: 'CC', label: '仓储服务' },
        { value: 'JG', label: '监管服务' },
      ],
    },
    {
      name: '开标日期',
      prop: 'bidOpeningDate',
      type: 'startDaterangePicker',
    },
    {
      name: '截标日期',
      prop: 'bidClosingDate',
      type: 'endDaterangePicker',
    },
    {
      name: '项目开始日期',
      prop: 'projectStartDate',
      type: 'startDaterangePicker',
    },
    {
      name: '项目结束日期',
      prop: 'projectEndDate',
      type: 'endDaterangePicker',
    },
  ];
};
